<template>
  <div :class="{ 'ac-item--selected': selected }" class="ac-item">
    <div class="ac-item__body">
      <slot>
        <entity-picker-item :item="pickerItem"/>
      </slot>
    </div>
    <v-icon v-if="selected" aria-hidden="true" class="ac-item__check" small>mdi-check</v-icon>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import EntityPickerItem from '@/components/common/entity-picker/EntityPickerItem.vue';
import {PickerEntity, PickerItem} from '@/components/common/entity-picker/entityPicker.types';

/**
 * Shared menu row of all autocompletes: icon/avatar + label + context line (EntityPickerItem) and a subtle check
 * for selected rows. Use inside a Vuetify `item` slot: <ac-item :item="item" :selected="attrs.inputValue"/>.
 * The default slot replaces the body for items that are not PickerItems.
 */
export default Vue.extend({
  name: 'AcItem',
  components: {EntityPickerItem},
  props: {
    item: {type: Object as () => PickerItem | Record<string, any>, required: false},
    selected: {type: Boolean, default: false},
    /** Item text key when the list uses `item-text` (e.g. "name") */
    textKey: {type: String, default: 'text'},
    /** Avatar of items that don't bring their own entity/icon */
    entity: {type: String as () => PickerEntity, default: undefined},
    icon: {type: String, default: undefined},
  },
  computed: {
    pickerItem(): PickerItem {
      const item = (this.item || {}) as Record<string, any>;
      const text = this.textKey !== 'text' && item.text === undefined ? item[this.textKey] : item.text;
      const avatar = item.entity || item.icon ? {} : {entity: this.entity, icon: this.icon};
      return {...item, ...avatar, text: String(text ?? '')} as PickerItem;
    },
  },
});
</script>

<style src="./autocomplete.css"></style>
